import { useEffect, useState, useContext, useCallback } from 'react';
import { getBannerQueryParams } from '../utils/requestUrlHelpers';
import { getFromBannerApi } from '../utils/axios';
import { ExperienceContext } from '~/@thd-nucleus/experience-context';
import { triggerNewRelic } from '../utils/helpers';
import { newRelicConstants } from '../constants';
import { PIP_BANNER_AB_TESTING_HEADER_KEY } from '../constants/constants';

/**
 *Make api request to sponsored banner api
 * if (requestConfig.callBanner == true)
 * */
const useFetch = (requestConfig) => {

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState(null);
  const experienceContext = useContext(ExperienceContext);
  const hosts = experienceContext.hosts;
  const bannerHost = hosts.apionline;

  const fetchData = async () => {

    let response = {};
    try {
      const queryParams = getBannerQueryParams(requestConfig);
      return await getFromBannerApi(bannerHost, { params: queryParams, withCredentials: true });
    } catch (err) {

      if (err.name === 'AbortError') {
        console.log('Fetch aborted');
      } else {
        setError(err.message);
        setStatus(response.status);
      }
      return err;
    }
  };

  useEffect(() => {
    const abortController = new AbortController();
    if (requestConfig.callBannerApi && experienceContext?.mounted && requestConfig?.browserId) {

      fetchData().then((response) => {
        if ((response.status === 200 || response.status === 204) && response.headers[PIP_BANNER_AB_TESTING_HEADER_KEY]) {
          triggerNewRelic(newRelicConstants.PIP_BANNER, `PIP-BANNER-AB-TEST-${response.headers[PIP_BANNER_AB_TESTING_HEADER_KEY]}`);
        }
        setData(response.data);
        setStatus(response.status);
      }
      );
    }

    return () => abortController.abort();
  }, [requestConfig?.browserId, experienceContext?.mounted]);

  return { data, status, error };
};

export default useFetch;
